export const isInWebView = () => {
  if (!window.ReactNativeWebView) return false;
  return true;
};

export const isEmbeddedInWallet = () => {
  if (!isInWebView()) return false;

  const source = window?.tlb?.source;

  if (!source) return false;
  return source === 'wallet';
};

export const getAppToken = () => {
  if (!isEmbeddedInWallet()) return null;
  const app = window?.tlb?.app;
  if (!app) return null;
  return app;
};
